import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/users'

class UserService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  async getUsers () {
    const result = await this._apiConsume.getData(BASE_URL)
    return result?.data
  }

  async getUser (id) {
    const path = id ? `${BASE_URL}/${id}` : '/api/dashboard/profile'
    const result = await this._apiConsume.getData(path)
    return result?.data
  }

  async createUser ({ username, email, password, type = 0 }) {
    const result = await this._apiConsume.postData({ username, email, password, type }, BASE_URL)
    return result?.data
  }

  async updateUser (id, { username, email, password, type }) {
    const result = await this._apiConsume.putData({ username, email, password, type }, `${BASE_URL}/${id}`)
    return result?.data
  }

  async deleteUser (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }

  async getSessions () {
    const result = await this._apiConsume.getData('/api/dashboard/token')
    return result?.data
  }

  async createSession (deviceName) {
    const result = await this._apiConsume.postData({ deviceName }, '/api/dashboard/token')
    return result?.data
  }

  async deleteSession (id) {
    const result = await this._apiConsume.deleteData(`/api/dashboard/token/${id}`)
    return result?.data
  }

  async logout () {
    const result = await this._apiConsume.postData({}, '/api/dashboard/logout')
    sessionStorage.clear()
    return result?.data
  }
}

export default UserService
